import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';

import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { AppStore } from '../store/AppStore';
import { flatMap, first } from 'rxjs/operators';

@Injectable()
export class HttpSecurityTimeoutInterceptor implements HttpInterceptor {

    public API_TIMEOUT = 30000;
    
    constructor(private store: Store<AppStore>) { }
  
    intercept (req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return this.store.select('userState').pipe(
            first(),
            flatMap(userState => {
                const authReq = !!userState ? req.clone({
                    setHeaders: { 
                        Authorization: 'Bearer ' + userState.token
                    },
                }) : req;
                return next.handle(authReq)
                    .timeout(this.API_TIMEOUT);
            })
        );
    }
}


// WEBPACK FOOTER //
// ./src/services/HttpSecurityTimeoutInterceptor.ts